import { CommonModule, DatePipe } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LocalizeRouterModule } from '@gilsdav/ngx-translate-router';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { SwiperModule } from 'swiper/angular';

import { AttendeeModule } from '~/attendee/attendee.module';
import { AuthGuard } from '~/auth/guards/auth.guard';
import { AuthModule } from '~/auth/auth.module';
import { ComponentModule } from '~/component/component.module';
import { CoreModule } from '~/core/core.module';
import { FreeCheckoutProfileCompleteGuard } from '~/checkout/guards/free-checkout-profile-complete.guard';
import { ParamethorModule } from '~/paramethor/paramethor.module';

import { BillingAddressComponent } from './components/pages/billing-address/billing-address.component';
import { BirthdaySportComponent } from './components/pages/birthday-sport/birthday-sport.component';
import { CanAccessCheckoutGuard } from './guards/can-access-checkout.guard';
import { CheckoutLayoutComponent } from './components/shared/layout/layout.component';
import { CheckoutPaymentComponent } from './components/pages/payment/payment.component';
import { CheckoutPaymentOnePayComponent } from './components/pages/payment/onepay/payment-onepay.component';
import { CheckoutPaymentPromoCodeComponent } from './components/pages/payment/promo-code/payment-promo-code.component';
import { ConfirmationComponent } from './components/pages/confirmation/confirmation.component';
import { FailureComponent } from './components/pages/failure/failure.component';
import { ProfileCompleteGuard } from './guards/profile-complete.guard';
import { ProfileComponent } from './components/pages/profile/profile.component';
import { SubscriptionComponent } from './components/pages/subscription/subscription.component';
import { SummaryComponent } from './components/pages/summary/summary.component';
import { RedirectBookingComponent } from '~/attendee/components/shared/redirect-booking/redirect-booking.component';
import { BookingIdResolver } from '~/organizer/shared/resolvers/booking-id-resolver/booking-id.resolver';

const routes = [
  {
    path: 'checkout.birthday-sport',
    component: BirthdaySportComponent,
  },
  {
    path: 'checkout.subscription',
    component: SubscriptionComponent,
  },
  {
    path: 'checkout.summary',
    component: SummaryComponent,
    canActivate: [CanAccessCheckoutGuard, FreeCheckoutProfileCompleteGuard],
  },
  {
    path: 'checkout.billing-address',
    component: BillingAddressComponent,
    canActivate: [CanAccessCheckoutGuard, AuthGuard, ProfileCompleteGuard],
  },
  {
    path: 'checkout.payment',
    component: CheckoutPaymentComponent,
    canActivate: [CanAccessCheckoutGuard, AuthGuard, ProfileCompleteGuard],
  },
  {
    path: 'checkout.confirmation.free',
    component: ConfirmationComponent,
    canActivate: [CanAccessCheckoutGuard, AuthGuard],
    data: { type: 'free' },
  },
  {
    path: 'checkout.booking/:id/checkout.status',
    component: RedirectBookingComponent,
    canActivate: [CanAccessCheckoutGuard, AuthGuard],
    resolve: {
      bookingId: BookingIdResolver,
    },
  },
  {
    path: 'checkout.confirmation.success',
    component: ConfirmationComponent,
    canActivate: [CanAccessCheckoutGuard, AuthGuard],
    data: { type: 'paying' },
  },
  {
    path: 'checkout.failure',
    component: FailureComponent,
    canActivate: [CanAccessCheckoutGuard, AuthGuard],
  },
  {
    path: 'checkout.information',
    component: ProfileComponent,
    canActivate: [CanAccessCheckoutGuard, AuthGuard],
  },
];

/**
 * Checkout pipe
 */
@NgModule({
  declarations: [
    BillingAddressComponent,
    BirthdaySportComponent,
    CheckoutLayoutComponent,
    ConfirmationComponent,
    FailureComponent,
    ProfileComponent,
    SubscriptionComponent,
    SummaryComponent,

    // Payment page
    CheckoutPaymentComponent,

    // OnePay related
    CheckoutPaymentPromoCodeComponent,

    // OnePay related
    CheckoutPaymentOnePayComponent,
  ],
  imports: [
    AttendeeModule,
    AuthModule,
    CommonModule,
    ComponentModule,
    CoreModule,
    FormsModule,
    LocalizeRouterModule.forChild(routes),
    ReactiveFormsModule,
    RouterModule.forChild(routes),
    SwiperModule,
    ParamethorModule,
  ],
  providers: [DatePipe],
})
export class CheckoutModule {}
